export interface CategoryEntry {
  name: string;
  code: string;
  description: string;
}

export interface TaxonomyEntry {
  code: string; // upstream taxonomy includes 51 codes; ConditionCode is the
  // observer-emitted subset only
  name: string;
  short_name: string;
  category: string;
  category_code: string;
  short_description: string;
  full_description: string;
  vectors: string[];
  has_observer: boolean;
}

export interface TaxonomyDoc {
  source: string;
  taxonomy_name: string;
  version: string;
  infection_vectors: string[];
  categories: CategoryEntry[];
  conditions: TaxonomyEntry[];
}

import { BASE } from "../lib/env";

let cache: Promise<TaxonomyDoc> | null = null;

export function loadTaxonomy(): Promise<TaxonomyDoc> {
  if (!cache) {
    cache = fetch(`${BASE}/data/taxonomy.json`).then((r) => {
      if (!r.ok) throw new Error(`taxonomy fetch failed: ${r.status}`);
      return r.json() as Promise<TaxonomyDoc>;
    });
  }
  return cache;
}
